export const selectSalesSubmit = (state) => state.salesSubmit;
